import { createAsyncThunk } from '@reduxjs/toolkit'
import Feedback from './feedback-model'
import {
  delete_feedback,
  load_feedbacks,
  store_feedback,
} from './feedback-service'

export const LoadFeedbacksAsync = createAsyncThunk<any, any>(
  'composer/load/feedback',
  async (params: { uid: string }) => {
    return await load_feedbacks(params)
  },
)

export const CreateFeedbackAsync = createAsyncThunk<any, any>(
  'composer/create/feedback',
  async (params: Feedback) => {
    return await store_feedback(params)
  },
)

export const DeleteFeedbackAsync = createAsyncThunk<any, any>(
  'composer/delete/feedback',
  async (params) => {
    return await delete_feedback(params)
  },
)
